import * as React from 'react';
import { Card, Form, Spinner } from "react-bootstrap";
import './ChangeDebitOrderDate.css';

export interface ChangeDebitOrderDateProps {
    debitOrderDateList: { text: string, value: string }[];
    debitOrderDate: string;
    saving?: boolean;
    emitHandleChangeDebitOrderDate: any;
    loading?: boolean;
}

interface State {
    selected: {
        text: string;
        option: string;
    },
    debitDay: string;
    authorize: boolean;
    selectedOptionText: string | null;
}

export class ChangeDebitOrderDate extends React.Component<ChangeDebitOrderDateProps,State> {
    constructor(props: ChangeDebitOrderDateProps) {
        super(props);
        
        this.state = {
            selected: {
                text: '',
                option: '',
            },
            selectedOptionText: null,
            debitDay: props.debitOrderDate ? props.debitOrderDate : '',
            authorize: false,
        };
        
        this.handleChangeDebitOrderDate = this.handleChangeDebitOrderDate.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    
    handleChange(e: any) {
        let value = e.target.value;
        if (e.target.id === "LifeDebitOrderDateChangeAuthorizeSwitch") {
            if (value === "on") {
                value = true;
            } else if (value === "off") {
                value = false;   
            }
            this.setState({
                ...this.state,
                [e.target.name]: value,
            });
        } else {
            let text = e.target.options[e.target.selectedIndex].text;
            
            this.setState({
                ...this.state,
                [e.target.name]: value,
                selectedOptionText: text,
            });
        }
    }
    
    handleChangeDebitOrderDate() {
        if (this.state.authorize) {
            this.props.emitHandleChangeDebitOrderDate(this.state.debitDay, this.state.selectedOptionText)
        } else {
            // Not switch on
        }
    }
    
    public render() {
        return (
            <Card className="col-12 col-md-6 p-1 change-debit-order pb-3">
                <Card.Header className="p-0 m-3">
                    <Card.Title className="change-debit-order__title">
                        <h2>Change debit order date</h2>
                    </Card.Title>
                    <Card.Subtitle>
                        <p className="mt-2 mb-1">Current debit order date is</p>
                        <p className="font-weight-bold change-debit-order__debit-day mt-1">{ this.props.debitOrderDate }</p>
                    </Card.Subtitle>
                </Card.Header>
                <Card.Body>
                    { this.props.loading !== true && <div className="row">
                        <div className="col-12 mb-1 mb-md-0">
                            <p className="change-debit-order__description">Please choose the day of the month on which you'd like your account to be debited</p>
                        </div>
                        <div className="col-12">
                            <Form.Group>
                                <Form.Label className="font-weight-bold ">Select a new debit order date</Form.Label>
                                <Form.Control value={this.state.debitDay} name="debitDay" onChange={this.handleChange} as="select" className="mt-1 ssp-select">
                                    { this.props.debitOrderDateList?.map((option, idx) => <option value={option.value} key={idx}>{option.text}</option> )}
                                </Form.Control>
                              </Form.Group>
                        </div>
                        <div className="col-12 mb-3">
                            <Form.Group onChange={this.handleChange}>
                                <Form.Check id="LifeDebitOrderDateChangeAuthorizeSwitch" name="authorize" className="change-debit-order__switch" type="switch" label={`I authorise King Price to collect my premium monthly from my bank account on the ${ this.state.selectedOptionText ? this.state.selectedOptionText : this.state.debitDay}`} />
                            </Form.Group>
                        </div>
                        <div className="col-12">
                            <button onClick={this.handleChangeDebitOrderDate} className="btn btn-solid-green w-100">Change debit order date</button>
                        </div>
                    </div>
                    ||
                    <Spinner className="d-block mx-auto mb-2" animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    }
                </Card.Body>
            </Card>
        )
    }
}